<template>
  <confirm-dialog-with-icon
    icon="trashM"
    :title="`${$t('common.cancelEvent')}?`"
    :description="description"
    :accept-btn-text="t('common.remove')"
    :is-loading="isLoading"
    @yes="cancelEvent"
  />
</template>

<script setup lang="ts">
import { safeInject, closeDialogKey } from '@wui/common-library'
import { computed, ref } from 'vue'

import { useRoomScheduleStore } from '@/entities/schedule'

import { ConfirmDialogWithIcon } from '@/shared/components/dialogs'
import { useLocalization } from '@/shared/composables/localization'

const { t } = useLocalization()
const roomScheduleStore = useRoomScheduleStore()
const { disable } = roomScheduleStore
const closeModal = safeInject(closeDialogKey)

const isLoading = ref(false)

const props = defineProps<{
  scheduledEventName: string
  scheduledEventUid: string
  pServed: string
}>()

const description = computed(() => {
  return t('common.areYouSureYouWantToCancelTheEvent', { eventName: props.scheduledEventName })
})

const cancelEvent = async () => {
  isLoading.value = true
  try {
    await disable(props.pServed, props.scheduledEventUid)
    closeModal(false)
  } finally {
    isLoading.value = false
  }
}

</script>
